// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29pX_","controls":"styles_controls__3j27Q","charLimit":"styles_charLimit__155Du","input":"styles_input__2VWY_","send":"styles_send__PGsn8"};